/**
 * This component is used to display a player's information in a game.
 */
import React from "react";
import ProfileImageContainer from "../core/ProfileImageContainer.js";
import { Link } from "react-router-dom";

const AllStar = ({
                     player,
                     extraClasses,
                     title,
                     nm=false
                 }) => {
    console.log(player)

    return (
        <Link to={`/player/${player.id}`} className={`mt-2 group ${extraClasses}`}>
            <div className="flex flex-col w-26 md:w-40 items-center justify-start">
                <p className="text-center leading-tight">{title}</p>
                <div className="md:w-24 md:h-24 w-14 h-14 mb-1">
                    <ProfileImageContainer
                        player={player.id}
                        club={player.stats.club}
                        backup={player.stats.team_img}
                        alt={player.forename[0] + ". " + player.surname}
                        extraClasses={"rounded"}
                    />
                </div>
                <div className="w-full pt-1 flex flex-col items-center justify-center max-xs:w-28 xs:w-36">
                    <p className="text-center leading-tight text-xxs md:text-xs group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200 max-sm:w-20 max-xs:overflow-x-clip">
                        {player.forename[0] + ". " + player.surname}
                    </p>
                    <p className="px-4 text-center mt-0.5 leading-tight text-xxs font-light text-darken max-sm:hidden">
                        {player.stats.team_name}
                    </p>
                    <p className="px-4 text-center mt-0.5 leading-tight text-xxs font-light text-darken sm:hidden">
                        {player.stats.team_short}
                    </p>
                    <p className="px-4 text-center mt-0.5 leading-tight text-xxs font-light text-darken">
                        {(!nm) ?
                            <><b>G:</b> {player.stats.goals} <b>A:</b> {player.stats.assists} <span className="max-xs:hidden"><b>PTS:</b> {player.stats.points}</span></> :
                            <><b>SAV%:</b> {player.nm_stats.sav.toFixed(2)}</>
                        }
                    </p>
                </div>
            </div>
        </Link>
    );
};
export default AllStar;
